import moment from 'moment/moment';

import { DealSheetRulesFilterType } from './types';
import { DealSheetRulesFilters } from './filters/cards';

export const initialDealSheetRulesFiltersValue: DealSheetRulesFilters = {
  [DealSheetRulesFilterType.CREATE_DATE_RANGE]: {
    to: moment().endOf('month'),
    from: moment().startOf('month'),
  },
  [DealSheetRulesFilterType.CUSTOMER_TYPE]: [],
  [DealSheetRulesFilterType.PAYMENT_TYPE]: [],
  [DealSheetRulesFilterType.EQUIPMENT_TYPE]: [],
};
